window.lazySizesConfig = window.lazySizesConfig || {};

import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes';
import lity from 'lity';

import './modules/lazymods';

import $ from 'jquery';

//import shopify from './modules/shopify';
import productFilter from './modules/productFilter';
import menuFlyout from './modules/menuFlyout';
import dropdowns from './modules/dropdowns';
import announcementBar from './modules/announcementBar';
import subscribeTeaser from './modules/subscribeTeaser';
import videos from './modules/videos';
import youtubeFeed from './modules/youtube-feed';
import tabs from './modules/tabs';
import accordion from './modules/accordion';
import catCafeSelect from './modules/catCafeSelect';
import blogReel from './modules/blog-reel';
import litterQuiz from './modules/litterQuiz';
import scrollScout from './modules/scrollScout';
import storybook from './modules/storybook';
import './modules/forms';
import './modules/masonry';

document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className += ' dom-loaded';
  productFilter.init();
  menuFlyout.init();
  dropdowns.init();
  announcementBar.init();
  subscribeTeaser.init();
  videos.plyr.init();
  youtubeFeed.init();
  tabs.init();
  accordion.init();
  catCafeSelect.init();
  litterQuiz.init();
  blogReel.init();
  scrollScout.init();
  storybook.init();

  $('.chad-the-cat__nope').on('click', function(e) {
    $(this).closest('.chad-the-cat').addClass('chad-the-cat--hidden');
  });

  try {
    var popups = document.querySelectorAll('.site-popup');

    [].forEach.call(popups, popup => {

      if ( popup && popup.dataset.popupOnPageLoad ) {
        var popupHash = popup.dataset.popupHash;
        var popupHideFor = parseInt(popup.dataset.popupHideFor);
        var popupCookieName = `sitePopupSeen_${ popupHash }`;
        var popupCookieExists = (document.cookie.indexOf(popupCookieName) != -1);

        if ( !popupCookieExists ) {
          var popupInstance = lity(`[data-popup-hash="${ popupHash }"]`);
          $(document).on('lity:close', function(event, instance) {
            // check if closed popup is a .site-popup
            if ( instance.element().find('.site-popup').length ) {
              // set popupCookieExists
              var popupCookieDate = new Date();
              var popupCookieExpires = popupCookieDate.toUTCString(popupCookieDate.setTime(popupCookieDate.getTime() + (popupHideFor*60*60*1000)));
              document.cookie = popupCookieName + '=true;expires=' + popupCookieExpires + '; path=/';
            }
          });
        }
      }

    });

  } catch(e) {}
});

